/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useRef, useState } from 'react';
import { useSelector } from 'react-redux';
import moment from 'moment';
import { translator } from '@vantiva-sa/homesight_humaui/Store/configStore';
import { apiCallback } from '@vantiva-sa/homesight_humaui/Services/Common';
import { AppStorageKeys } from '@vantiva-sa/homesight_humaui/Utilities/Constants';
import SessionStorage from '@vantiva-sa/homesight_humaui/Utilities/SessionStorage';

const DefaultNumberOfDays = 7;
const ENV_VARS = SessionStorage.get(AppStorageKeys.envVars);
const NOTIFICATIONS_NUMBER_OF_DAYS = ENV_VARS.NOTIFICATIONS_NUMBER_OF_DAYS;

const NumberOfDays = NOTIFICATIONS_NUMBER_OF_DAYS ?? DefaultNumberOfDays;

const useNotification = ({
  useruuid,
  startdatetime,
  enddatetime,
  notificationtypes,
  details = true,
  callhistory = false,
  fetchDays = NumberOfDays,
}) => {
  const [data, setData] = useState([]);
  const [fetchingData, setFetchingData] = useState(!!useruuid);

  const trans = useSelector(translator);
  const notificationApi = useSelector((state) => state.apis.notificationApi);
  const latestRequestRef = useRef(0);

  /* onComplete receives the fetched list, or null on error or when superseded by a newer fetch. */
  const fetchData = (days, { skipClear = false, onComplete } = {}) => {
    const requestId = ++latestRequestRef.current;
    const isLatestRequest = () => requestId === latestRequestRef.current;
    const errorCallback = (error) => {
      if (isLatestRequest()) setFetchingData(false);
      console.error('Error fetching notifications:', error);
      onComplete?.(null);
    };
    const successCallback = (data) => {
      if (!isLatestRequest()) {
        onComplete?.(null);
        return;
      }
      const list = data?.notificationlist ?? [];
      setFetchingData(false);
      setData(list);
      onComplete?.(list);
    };
    try {
      let dayOffset = days ?? fetchDays;
      let endDateTime = enddatetime ? moment(enddatetime).format() : moment().format();
      let startDateTime = startdatetime
        ? moment(startdatetime).format()
        : moment(endDateTime).subtract(dayOffset, 'day').format();
      /* Notification api requires datetime in UTC */
      startDateTime = moment(startDateTime).utc().format();
      endDateTime = moment(endDateTime).utc().format();
      let notificationTypes =
        notificationtypes ??
        (callhistory ? ['call_status'] : ['call_status', 'calendar', 'contact']);
      if (!useruuid) {
        onComplete?.(null);
        return;
      }
      if (!skipClear) setData([]);
      setFetchingData(true);
      notificationApi.getNotificationsByTimeRange(
        useruuid,
        startDateTime,
        endDateTime,
        { notificationtypes: notificationTypes },
        { details },
        apiCallback({
          translator: trans,
          failCallback: errorCallback,
          errorCallback,
          successCallback,
        })
      );
    } catch (error) {
      errorCallback(error);
    }
  };

  useEffect(
    () => fetchData(),
    [useruuid, startdatetime, enddatetime, notificationtypes, callhistory]
  );

  return [data, fetchingData, fetchData];
};

export default useNotification;
